import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

// Removed Tubing imports
import EditPumpInternationalSO from "./PumpInternatinalSO/EditPumpInternational";
import EditPumpDomesticSO from "./PumpDomesticSO/EditPumpDomesticSO";
import EditAraiMfgIntSO from "./AraiMfgSo/EditAraiMfgIntSO";
import EditAraiMfgDomesticSO from "./AraiMfgDomesticSO/EditAraiMfgDomesticSO";

const EditSalesOrder = () => {
  const navigate = useNavigate();
  const { id, pointindex } = useParams();
  const [productType, setProductType] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [enquiryData, setEnquiryData] = useState();

  async function getData() {
    try {
      const response = await axios.get(`${BASE_URL}salesOrder/findById/${id}`, {
        headers: authHeader(),
      });

      console.log(response);

      setEnquiryData(response.data);
      setProductType(response.data.salesordertype);
      setProductCategory(response.data.salesordercategory);
    } catch (error) {
      console.log(error);
    }
  }

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <EditPumpDomesticSO enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <EditPumpInternationalSO enquiryData={enquiryData} />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <EditAraiMfgDomesticSO enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <EditAraiMfgIntSO enquiryData={enquiryData} />;
      }
    }
    return null;
  }

  useEffect(() => {
    getData();
  }, []);

  console.log(enquiryData);

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>Edit Sales Order</h6>
          <div className="view-buttons">
            <Link to={`/salesOrderIndexTable/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Sales Order Type:</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setProductType(e.target.value);
                  }}
                  value={productType}
                  disabled={!!productType}
                >
                  <option value="">--Please choose an option--</option>
                  {/* Removed Tubing option */}
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Sales Order Category:</Form.Label>
                <Form.Select
                  disabled={
                    !productType ||
                    productType === "arai-mfg" ||
                    !!productCategory
                  }
                  value={
                    productType === "arai-mfg" ? "International" : productCategory
                  }
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
  );
};

export default EditSalesOrder;
